import React from "react";
import BusDetailsCard from "./BusDetailsCard";

export default function Bus7() {
  return (
    <BusDetailsCard
      busId="bus7"
      title="Bus 7 - Route Details"
      busName="Bus 7"
      vehicleNo="TN74G7234"
      backTo="/?buses=1"
    />
  );
}